import { render, staticRenderFns } from "./showOwnerRoom.vue?vue&type=template&id=b480e040&scoped=true"
import script from "./showOwnerRoom.vue?vue&type=script&lang=js"
export * from "./showOwnerRoom.vue?vue&type=script&lang=js"
import style0 from "./showOwnerRoom.vue?vue&type=style&index=0&id=b480e040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b480e040",
  null
  
)

export default component.exports